<div class="history-panel">
  <header class="history-header">
    <div>
      <h2 class="history-title">Change History</h2>
      <p class="history-subtitle">
        Field-level audit log for project metadata. Each version can be restored.
      </p>
    </div>
    <button mat-stroked-button type="button" (click)="loadHistory()" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
  </header>

  <div *ngIf="loading" class="history-state">
    <mat-spinner diameter="36"></mat-spinner>
    <span>Loading history…</span>
  </div>

  <div *ngIf="!loading && error" class="history-state history-error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error }}</span>
  </div>

  <div *ngIf="!loading && !error && entries.length === 0" class="history-state">
    <mat-icon>history</mat-icon>
    <span>No changes recorded yet.</span>
  </div>

  <div *ngIf="!loading && !error && entries.length > 0" class="timeline">
    <article
      *ngFor="let entry of entries"
      class="timeline-item"
      [class.expanded]="expandedVersion === entry.version"
    >
      <div class="timeline-marker" [ngClass]="changeTypeClass(entry.change_type)"></div>

      <div class="timeline-card">
        <div class="timeline-card-header">
          <div class="timeline-meta">
            <span class="version-badge">v{{ entry.version }}</span>
            <span class="change-badge" [ngClass]="changeTypeClass(entry.change_type)">
              {{ changeTypeLabel(entry.change_type) }}
            </span>
            <span class="timeline-date">{{ entry.changed_at | date: 'medium' }}</span>
          </div>
          <div class="timeline-actions">
            <button
              mat-button
              type="button"
              (click)="toggleExpand(entry.version)"
              *ngIf="entry.field_changes?.length"
            >
              {{ expandedVersion === entry.version ? 'Hide' : 'Show' }}
              {{ entry.field_changes.length }} change(s)
            </button>
            <button
              mat-flat-button
              color="primary"
              type="button"
              *ngIf="canRestore(entry)"
              [disabled]="restoring"
              (click)="confirmRestore(entry)"
            >
              Restore
            </button>
          </div>
        </div>

        <p class="timeline-summary">{{ entry.change_summary }}</p>
        <p class="timeline-user" *ngIf="entry.changed_by_name || entry.changed_by">
          By {{ entry.changed_by_name || ('User #' + entry.changed_by) }}
        </p>

        <div class="field-changes" *ngIf="expandedVersion === entry.version && entry.field_changes?.length">
          <table>
            <thead>
              <tr>
                <th>Field</th>
                <th>Previous</th>
                <th>New</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let fc of entry.field_changes">
                <td class="field-name">{{ fieldLabel(fc.field_name) }}</td>
                <td class="old-value">{{ displayValue(fc.old_value, fc.field_name) }}</td>
                <td class="new-value">{{ displayValue(fc.new_value, fc.field_name) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </article>
  </div>
</div>
